var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 28 20","fill":_vm.fill,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.92268 20.0001L0.442383 10.5198L2.81246 8.14973L9.92268 15.2599L25.1826 0L27.5527 2.37007L9.92268 20.0001Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }